<!-- eslint-disable @angular-eslint/template/eqeqeq -->
@if (!hideLoader && !rules) {
  <app-loader></app-loader>
}
@if (rules) {
  <form [formGroup]="rules" class="rulesForm">
    <div formArrayName="rulesGroups">
      @for (RulesGroup of getRulesGroups(rules); track RulesGroup; let i = $index) {
<div class="rule-block
      margin-vertical-10">
          @if (!this.config.singleGroup && !config.fixedRules) {
            <div class="padding-vertical-4 text-right delete-group-link"
              >
              @if (getRulesGroups(rules).length>1) {
                <a (click)="removeRulesGroup(i)" href="#" translate>
                  Delete Group
                </a>
              }
            </div>
          }
          <div [formGroupName]="i" class="rule-block-inner padding-10">
            <div formArrayName="rules">
              @for (Rule of getRuleLines(RulesGroup); track Rule; let j = $index) {
                <div [formGroupName]="j"
                  class="padding-vertical-4 padding-horizontal-4 margin-vertical-4">
                  <div class="rulesGroup">
                    <!-- readonly parameter -->
                    @if (config.fixedRules || config.fixedPredicate) {
                      <mat-form-field class="comparisonPredicate">
                        <mat-label translate>Parameter</mat-label>
                        <input matInput readonly [value]="getPredicateName(Rule.get('comparisonPredicate').value)" />
                      </mat-form-field>
                    }
                    <!-- selectable parameter - autocomplete -->
                    @if (!config.fixedRules && !config.fixedPredicate && autocompleteFieldName) {
                      <app-rule-engine-predicate
                        formControlName="comparisonPredicate" class="comparisonPredicate" [rulesOptions]="rulesOptions"
                        [ruleFields]="usedRuleFields" (selectionChange)="resetLineDataOnChange($event, Rule)">
                      </app-rule-engine-predicate>
                    }
                    <!-- selectable parameter - dropdown list -->
                    @if (!config.fixedRules && !config.fixedPredicate && !autocompleteFieldName) {
                      <mat-form-field class="comparisonPredicate">
                        <mat-label translate>Choose Parameter</mat-label>
                        <mat-select matNativeControl formControlName="comparisonPredicate" #comparisonPredicate
                          class="padding-horizontal-4" (selectionChange)="onPredicateChange(Rule)">
                          @for (group of ruleFieldGrouped; track group) {
                            <mat-optgroup>
                              <mat-label translate>{{predicateGroupNameByValue(group.group)}}</mat-label>
                              @for (rule of group.fields; track rule) {
                                <mat-option [value]="rule.predicate" #opt
                                  [disabled]="group.hidden" [matTooltip]="rule.description">
                                  <span translate>{{rule.name}}</span> @if (rule.description && !opt.selected) {
                                  <span class='predicate-description' translate
                                  >[{{rule.description}}]</span>
                                }
                              </mat-option>
                            }
                          </mat-optgroup>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  @if (ifDaysPredicate(Rule.get('comparisonPredicate').value) && !ifSalesforceField(Rule.get('comparisonPredicate').value)) {
                    <mat-form-field class="daysPredicate" floatLabel="always"
                      >
                      <mat-label></mat-label>
                      <mat-select matNativeControl formControlName="daysPredicate" class="padding-horizontal-4">
                        @for (option of daysPredicateOptions; track option) {
                          <mat-option [value]="option.name">{{option.label}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  <mat-form-field class="comparisonOperator">
                    <mat-label translate>Choose Operator</mat-label>
                    <mat-select matNativeControl formControlName="comparisonOperator" class="padding-horizontal-4"
                      (selectionChange)="onOperatorChange($event.value, Rule)">
                      @for (operator of getOptions(Rule.get('comparisonPredicate').value); track operator) {
                        <mat-option
                          [value]=" operator.name">{{operator.label}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <!-- single value -->
                  @if (
                    (Rule.get('comparisonOperator').value != 'StringNullOrEmpty' && Rule.get('comparisonOperator').value != 'StringNotNullOrEmpty') && (
                    getInputType(Rule.get('comparisonPredicate').value)==comparisonInputType.textField ||
                    getInputType(Rule.get('comparisonPredicate').value)==comparisonInputType.number ||
                    getInputType(Rule.get('comparisonPredicate').value)==comparisonInputType.url ||
                    getInputType(Rule.get('comparisonPredicate').value)==comparisonInputType.email ||
                    getInputType(Rule.get('comparisonPredicate').value)==comparisonInputType.dateTime) ||
                    Rule.get('comparisonOperator').value == 'CollectionElementContains') {
                    <mat-form-field class="comparisonValue">
                      <mat-label>{{getPlaceholder(Rule.get('comparisonPredicate').value)}}</mat-label>
                      <input matInput formControlName="comparisonValue">
                      @if (Rule.get('comparisonValue').invalid && (Rule.get('comparisonValue').dirty || Rule.get('comparisonValue').touched)) {
                        <div
                          class="error rule-error">
                          @if (Rule.get('comparisonValue').errors.required) {
                            <div translate>
                              The field is required.
                            </div>
                          }
                          @if (Rule.get('comparisonValue').errors.number) {
                            <div translate>
                              The field must contain only digits.
                            </div>
                          }
                          @if (Rule.get('comparisonValue').errors.email) {
                            <div translate>
                              The field must be a valid email address.
                            </div>
                          }
                          @if (Rule.get('comparisonValue').errors.url) {
                            <div translate>
                              The field must be a valid Url.
                            </div>
                          }
                          @if (Rule.get('comparisonValue').errors.dateError) {
                            <div translate>
                              The date must be in format 'YYYY/MM/DD'.
                            </div>
                          }
                        </div>
                      }
                    </mat-form-field>
                  }
                  <!-- multiselect values - not grouped -->
                  @if (getInputType(Rule.get('comparisonPredicate').value)==comparisonInputType.multiselect && !getPredicateValuesGroupedOrNot(Rule.get('comparisonPredicate').value)) {
                    <mat-form-field class="comparisonValue"
                      >
                      <mat-label>{{getPlaceholder(Rule.get('comparisonPredicate').value)}}</mat-label>
                      <mat-select multiple formControlName="comparisonArray">
                        @for (collection of getCollection(Rule.get('comparisonPredicate').value); track collection) {
                          <mat-option
                            [value]="printProperty(collection, 'id')">
                            {{printProperty(collection, 'name')}}
                          </mat-option>
                        }
                      </mat-select>
                      @if (Rule.get('comparisonArray').invalid && (Rule.get('comparisonArray').dirty || Rule.get('comparisonArray').touched)) {
                        <div
                          class="error rule-error">
                          @if (Rule.get('comparisonArray').errors.required) {
                            <div translate>
                              The field is required.
                            </div>
                          }
                        </div>
                      }
                    </mat-form-field>
                  }
                  <!-- multiselect values - grouped -->
                  @if (getInputType(Rule.get('comparisonPredicate').value)==comparisonInputType.multiselect && getPredicateValuesGroupedOrNot(Rule.get('comparisonPredicate').value)) {
                    <mat-form-field class="comparisonValue"
                      >
                      <mat-label>{{getPlaceholder(Rule.get('comparisonPredicate').value)}}</mat-label>
                      <mat-select multiple formControlName="comparisonArray">
                        @for (group of getCollection(Rule.get('comparisonPredicate').value) | keyvalue; track group) {
                          <mat-optgroup>
                            <mat-label translate>{{group.key}}</mat-label>
                            @for (collection of group.value; track collection) {
                              <mat-option [value]="printProperty(collection, 'id')">
                                {{printProperty(collection, 'name')}}
                              </mat-option>
                            }
                          </mat-optgroup>
                        }
                      </mat-select>
                      @if (Rule.get('comparisonArray').invalid && (Rule.get('comparisonArray').dirty || Rule.get('comparisonArray').touched)) {
                        <div
                          class="error rule-error">
                          @if (Rule.get('comparisonArray').errors.required) {
                            <div translate>
                              The field is required.
                            </div>
                          }
                        </div>
                      }
                    </mat-form-field>
                  }
                  <!-- single value from list -->
                  @if (getInputType(Rule.get('comparisonPredicate').value)==comparisonInputType.select) {
                    <mat-form-field class="comparisonValue"
                      >
                      <mat-label>{{getPlaceholder(Rule.get('comparisonPredicate').value)}}</mat-label>
                      <mat-select formControlName="comparisonValue">
                        @for (collection of getCollection(Rule.get('comparisonPredicate').value); track collection) {
                          <mat-option
                            [value]="printProperty(collection, 'id')">
                            {{printProperty(collection, 'name')}}
                          </mat-option>
                        }
                      </mat-select>
                      @if (Rule.get('comparisonValue').invalid && (Rule.get('comparisonValue').dirty || Rule.get('comparisonValue').touched)) {
                        <div
                          class="error rule-error">
                          @if (Rule.get('comparisonValue').errors.required) {
                            <div translate>
                              The field is required.
                            </div>
                          }
                        </div>
                      }
                    </mat-form-field>
                  }
                  <!-- autocomplete value -->
                  @if (getInputType(Rule.get('comparisonPredicate').value)==comparisonInputType.autocomplete) {
                    <mat-form-field class="comparisonValue full-width" floatLabel="always" [hideRequiredMarker]="true"
                      >
                      <mat-label></mat-label>
                      <app-multiselect-autocomplete formControlName="comparisonArray"
                        [itemsList]="getCollection(Rule.get('comparisonPredicate').value)"
                      [required]="true"></app-multiselect-autocomplete>
                    </mat-form-field>
                  }
                  <!-- free text multiple values -->
                  @if (getInputType(Rule.get('comparisonPredicate').value)==comparisonInputType.chips) {
                    <mat-form-field class="comparisonValue full-width"
                      >
                      <mat-chip-grid #value formControlName="comparisonArray">
                        @for (value of Rule.get('comparisonArray').value; track value) {
                          <mat-chip-row
                            (removed)="removeFromValuesArray(Rule.get('comparisonArray'), value)">
                            {{value}}
                            <button matChipRemove> <mat-icon>cancel</mat-icon> </button>
                          </mat-chip-row>
                        }
                        <input placeholder="add a value" [matChipInputFor]="value"
                          [matChipInputSeparatorKeyCodes]="chipsSeparatorKeysCodes" [matChipInputAddOnBlur]="true"
                          (matChipInputTokenEnd)="addToValuesArray(Rule.get('comparisonArray'), $event)">
                        </mat-chip-grid>
                        @if (Rule.get('comparisonArray').invalid && (Rule.get('comparisonArray').dirty || Rule.get('comparisonArray').touched)) {
                          <div
                            class="error rule-error">
                            @if (Rule.get('comparisonArray').errors.required) {
                              <div translate>
                                At least 1 value needs to be added
                              </div>
                            }
                          </div>
                        }
                      </mat-form-field>
                    }
                    <!-- free text autocomplete -->
                    @if (getInputType(Rule.get('comparisonPredicate').value)==comparisonInputType.freeTextAutocomplete && Rule.get('comparisonOperator').value != 'CollectionElementContains') {
                      <app-multi-freetext-autocomplete class="comparisonValue"
                        placeholderEmpty="Add a value" formControlName="comparisonArray"
                        [itemsList]="getCollectionValues(Rule.get('comparisonPredicate').value)" [required]="true">
                      </app-multi-freetext-autocomplete>
                    }
                    <!-- salesforce opprortunity value -->
                    @if (ifDaysPredicate(Rule.get('comparisonPredicate').value) && ifSalesforceField(Rule.get('comparisonPredicate').value)) {
                      <mat-form-field class="daysPredicate sfDaysPredicate"
                        >
                        <mat-select matNativeControl formControlName="daysPredicate" class="padding-horizontal-4">
                          @for (option of sfDaysPredicateOptions; track option) {
                            <mat-option [value]="option.name">{{option.label}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (!config.fixedRules && getRuleLines(RulesGroup).length>1) {
                      <mat-icon
                        matTooltip="{{'Delete Condition' | translate}}" (click)="removeRuleLine(i, j)"
                        class="margin-horizontal-4 colored-icon">
                      remove_circle</mat-icon>
                    }
                  </div>
                  @if (getRuleLines(RulesGroup).length > 1 && j < getRuleLines(RulesGroup).length-1) {
                    <div class="app-add-edit-buttons-left margin-vertical-4 padding-horizontal-10 comp-group-operator"
                      >
                      {{getGroupOperator(i)}}
                    </div>
                  }
                </div>
              }
            </div>
            @if (!config.fixedRules) {
              <div class="margin-vertical-4 padding-horizontal-10">
                <a (click)="addRuleLine(i)" href="#" translate>
                  + Add Condition
                </a>
              </div>
            }
            @if (!this.config.hideInGroupOperatorToggle && getRuleLines(RulesGroup).length > 1) {
              <div class="app-add-edit-buttons-left">
                <span translate>Relation between conditions:</span>
                <mat-button-toggle-group formControlName="rulesOperator" aria-label="" class="margin-horizontal-10">
                  <mat-button-toggle value="And">And</mat-button-toggle>
                  <mat-button-toggle value="Or">Or</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
              <ng-container *ngTemplateOutlet="conditionsRelationTemplate"></ng-container>
            }
          </div> <!-- rule-block-inner-->
          @if (!this.config.singleGroup && getRulesGroups(rules).length>1 && i < getRulesGroups(rules).length-1) {
            <div class="app-add-edit-buttons-left margin-vertical-4 padding-horizontal-10 comp-general-operator"
              >
              {{getGeneralOperator()}}
            </div>
          }
          @if (!this.config.singleGroup && !config.fixedRules && i==getRulesGroups(rules).length-1) {
            <div class="margin-vertical-10"
              >
              <a (click)="addRulesGroup()" class="margin-vertical-4" href="#" translate>
                + Add Conditions Group
              </a>
            </div>
          }
        </div>
      }
    </div>
    @if (!this.config.hideGroupsOperatorToggle && !this.config.singleGroup && getRulesGroups(rules).length>1) {
      <div class="app-add-edit-buttons-left">
        <span translate>Relation between groups:</span>
        <mat-button-toggle-group formControlName="rulesOperator" aria-label="" class="margin-horizontal-10">
          <mat-button-toggle value="And">And</mat-button-toggle>
          <mat-button-toggle value="Or">Or</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <ng-container *ngTemplateOutlet="conditionsRelationTemplate"></ng-container>
    }
    <div class="app-add-edit-buttons">
      @if (!this.config.fixedRules) {
        <a href="#" (click)="resetAllRules()">reset all</a>
      }
    </div>
    <br />
    <!--<div class="app-add-edit-buttons margin-vertical-10">
    <button mat-flat-button color="primary" type="submit" translate>Save</button>
    <button mat-flat-button class="flat-basic-button" (click)="onCancel()" translate>Cancel</button>
  </div>-->
</form>
}

<pre style="display: none;"> {{rules?.value | json}} </pre>

<ng-template #conditionsRelationTemplate>
  <div class="when-to-use">
    <div class="app-bold-font">When to use And or Or?</div>
    <div>
      Use AND when <b>ALL</b> conditions must be true.
      Think of AND as <b>"only apply when ALL rules are met"</b>.
    </div>
    <div>
      Use OR when <b>AT LEAST ONE</b> condition must be true.
      Think of OR as <b>"apply if ANY of these rules match"</b>.
    </div>
  </div>
</ng-template>
